import { fetchNewsData } from "features/News/services/news.service";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

const useMisinformationSearch = (setLoading) => {
  const [newsCards, setNewsCards] = useState([]);
  const { user } = useSelector((state) => state.auth);
  const { misinformationsearch } = useParams();
  const navigate = useNavigate();

  const getData = async (searchTerm) => {
    setLoading(true);

    if (searchTerm == null) {
      setNewsCards([]);
      setLoading(false);
      return;
    }

    const newsDataObj = await fetchNewsData(
      searchTerm,
      user,
      null,
      "Misinformation"
    );
    setNewsCards(newsDataObj);
    setLoading(false);
  };

  const handleSearch = (searchTerm) => {
    navigate(`/tools/dubious-sources-search/${encodeURI(searchTerm)}`);
  };

  useEffect(() => {
    getData(misinformationsearch);
    if (!misinformationsearch) {
      handleSearch("");
    }
  }, [misinformationsearch]);

  return { newsCards, handleSearch };
};

export default useMisinformationSearch;
